import { stitchDefaults } from './defaults';
import TeamComparisonModel from '../models/TeamComparisonModel';

export default {
    ...stitchDefaults,
    model: TeamComparisonModel,
    namespace: 'teamComparison',
    expires: 60,
    pathTemplate: 'bdfed/gameday-team-comparison?homeId={homeId}&awayId={awayId}&gameType={gameType}&endDate={gameDate}'
};